import React, { useContext, useEffect, useState } from "react";
import styles from "./header.module.css";
import { ReactComponent as Twitter } from "../../assets/img/footer/twitter.svg";
import { ReactComponent as Discord } from "../../assets/img/footer/discord.svg";
import { ReactComponent as Telegram } from "../../assets/img/footer/telegram.svg";
import HeaderLogo from "../../assets/img/header/headerLogo.png";
import clsx from "clsx";
import Button from "../UI/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { HeaderMobileMenuIsOpen } from "../../context/HeaderMobileMenuIsOpen";

const navLink = [
  { label: "Home", link: "homepage", isGoldColor: false  },
  { label: "Battle & Build", link: "battle&build", isGoldColor: false  },
  {
    label: "Foundry",
    externalLink: "https://foundry.mech.com", isGoldColor: false
  },
  { label: "World Map", externalLink: "https://world.mech.com/", isGoldColor: true  },
  { label: "About Us", link: "aboutUs", isGoldColor: false },
  { label: "Archive", externalLink: "https://archive.mech.com", isGoldColor: false },

];
const Header = () => {
  const [activeLink, setActiveLink] = useState("Home");
  const { headerMobileMenuIsOpen, setHeaderMobileMenuIsOpen } = useContext(
    HeaderMobileMenuIsOpen
  );
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    navLink.forEach((el) => {
      if (!el.link) {
        return;
      }
      if (location.pathname.includes(el.link)) {
        setActiveLink(el.label);
      }
    });
  }, []);
  return (
    <header className={styles.header}>
      <div>
        <img src={HeaderLogo} alt="header logo" className={styles.headerLogo} />
        <div
          className={clsx(styles.mobileMenuBtnBlock, {
            [styles.mobileMenuBtnBlockClose]: headerMobileMenuIsOpen,
          })}
          onClick={() => {
            setHeaderMobileMenuIsOpen(!headerMobileMenuIsOpen);
          }}
        >
          <div
            className={clsx(styles.mobileMenuBtn, {
              [styles.mobileMenuBtnClose]: headerMobileMenuIsOpen,
            })}
          />
        </div>
        <nav className={styles.headerNav}>
          {navLink.map((el, index) => (
            <div
              key={index}
              className={clsx(styles.navLinkItemWrapper, {
                [styles.navLinkItemWrapperActive]: activeLink === el.link,
              })}
            >
              <div
                className={clsx(styles.navLinkItem, {
                  [styles.navLinkItemActive]: activeLink === el.label,
                })}
                style={el.isGoldColor ?{color:'gold'} : {}}
                onClick={() => {
                  setActiveLink(el.label);
                  if (el.link) {
                    navigate(`/${el.link}`);
                  }
                  setHeaderMobileMenuIsOpen(false);
                }}
              >
                {el.externalLink ? (
                  <a href={el.externalLink}>{el.label}</a>
                ) : (
                  el.label
                )}
              </div>
            </div>
          ))}
        </nav>
        <div
          className={clsx(styles.mobileNavMenu, {
            [styles.mobileNavMenuActive]: headerMobileMenuIsOpen,
          })}
          
        >
          {navLink.map((el, index) => {
            if (el.externalLink) {
              return (
                <a
                  key={index}
                  onClick={() => {
                    setHeaderMobileMenuIsOpen(false);
                  }}
                  href={el.externalLink}
                >
                  <div
                    className={clsx(styles.navMobileLinkItem, {
                      [styles.navMobileLinkItemActive]: activeLink === el.link,
                    })}
                    style={el.isGoldColor ?{color:'gold'} : {}}

                  >
                    {el.label}
                  </div>
                </a>
              );
            } else
              return (
                <div
                  key={index}
                  className={clsx(styles.navMobileLinkItem, {
                    [styles.navMobileLinkItemActive]: activeLink === el.label,
                  })}
                  onClick={() => {
                    setActiveLink(el.label);
                    if (el.link) {
                      navigate(`/${el.link}`);
                    }
                    setHeaderMobileMenuIsOpen(false);
                  }}
                >
                  {el.label}
                </div>
              );
          })}
        </div>
      </div>
      <div className={styles.headerRightBlock}>
        <div>
          <Twitter
            onClick={() => {
              window.open("https://twitter.com/MechNFT");
            }}
          />
          {/* <Discord
            onClick={() => {
              window.open("https://discord.com/invite/mechnft");
            }}
          /> */}
          <Telegram
            onClick={() => {
              window.open("https://t.me/mechnft");
            }}
          />
        </div>
        {/* <Button isSmall={true}>Log In</Button> */}
      </div>
    </header>
  );
};

export default Header;
